import { render, staticRenderFns } from "./importMaterialDialog.vue?vue&type=template&id=0812d333&scoped=true&"
import script from "./importMaterialDialog.vue?vue&type=script&lang=js&"
export * from "./importMaterialDialog.vue?vue&type=script&lang=js&"
import style0 from "./importMaterialDialog.vue?vue&type=style&index=0&id=0812d333&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0812d333",
  null
  
)

export default component.exports